import styled from "styled-components";

export const Wrapper = styled.div`
  padding: 40px;
  transition: background-color 0.3s ease-in;

  .Container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 26px;
    flex-wrap: wrap;
  }
  .Container img {
    width: 500px;
    height: auto;
    flex-shrink: 0;
    margin-right: 8px;
  }
  .Container > div:last-child {
    flex: none;
  }
  .TitleMainHeading {
    font-size: 50px;
    line-height: 1;
    color: ${({ theme }) => theme.text};
    padding-bottom: 10px;
    font-family: "Roboto", "Montserrat", "Instruments-sans", sans-serif;
    font-weight: 500;
    word-spacing: -2px;
    max-width: 13em;
    text-align: flex-start;
  }
  .DescriptionMainHeading {
    font-size: 20px;
    color: ${({ theme }) => theme.text};
    padding-bottom: 20px;
    font-family: "Roboto", "Montserrat", "Instruments-sans", sans-serif;
    word-spacing: 5px;
    max-width: 25em;
    text-align: flex-start;
  }
  .DescriptionSubtext {
    color: ${({ theme }) => theme.subtext};
    font-weight: 700;
  }

  @media screen and (max-width: 768px) {
    padding: 20px 20px;

    .Container {
      flex-direction: column;
    }

    .Container img {
      width: 100%;
      max-width: 300px;
      margin: 0 auto 10px;
    }

    .TitleMainHeading,
    .DescriptionMainHeading {
      width: 100%;
      max-width: 350px;
      margin: 0 auto 20px;
      text-align: flex-start;
      padding: 0 10px;
    }

    .DescriptionMainHeading {
      padding-top: 0;
    }
  }
`;
